export const enum EModalSize {
  sm = 'sm',
  md = 'md',
  lg = 'lg',
  xl = 'xl',
};
